import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Briefcase, Handshake } from 'lucide-react';
import { Link } from 'react-router-dom';

export const JoinOurCircle = () => {
  const ctaOptions = [
    {
      title: 'Schedule a Consultation',
      desc: 'Start the conversation about your goals',
      icon: Calendar,
      link: '/book-consultation?source=home-join-circle',
      testid: 'join-schedule-cta'
    },
    {
      title: 'Explore Careers',
      desc: 'Join a culture of excellence and growth',
      icon: Briefcase,
      link: '/contact',
      testid: 'join-careers-cta'
    },
    {
      title: 'Partner with Us',
      desc: 'Build something greater together',
      icon: Handshake,
      link: '/contact',
      testid: 'join-partner-cta'
    }
  ];

  return (
    <section 
      id="join"
      className="bg-[linear-gradient(180deg,#0B2240_0%,#07182F_100%)] text-white py-16 lg:py-20"
      data-testid="join-our-circle-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6">
            Join Our Circle
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            We work best with those who value integrity, precision, and partnership. If that sounds like you, let's start the conversation.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ctaOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <motion.div
                key={option.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -4 }}
              >
                <Link
                  to={option.link}
                  className="group block rounded-2xl p-8 border border-white/15 bg-white/5 backdrop-blur-xl hover:bg-white/8 hover:border-white/25 hover:shadow-[0_12px_40px_rgba(11,34,64,.24)] transition-all duration-300 h-full"
                  data-testid={option.testid}
                >
                  <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 mb-6 mx-auto group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                    <Icon className="h-7 w-7 text-[#D4AF37]" />
                  </div>
                  <h3 className="font-['Playfair_Display'] text-xl font-semibold mb-3 text-center">
                    {option.title}
                  </h3>
                  <p className="text-sm text-white/70 text-center mb-4">
                    {option.desc}
                  </p>
                  <div className="flex items-center justify-center">
                    <ArrowRight className="h-5 w-5 text-[#D4AF37] group-hover:translate-x-1 transition-transform duration-200" />
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
